import Article from '~/components/Articles/Article'
import i18n from '~/i18n'
import { HOST } from '~/constants/host'
import { split } from 'lodash'
import { getArticle } from '~/apis'
import { parseArticle } from '~/hooks'

export const getServerSideProps = async ({ params }) => {
  const t = i18n.t
  const [articleId] = split(params?.articleId as string, '-')

  try {
    const data = await getArticle('en-us', articleId)
    const article = parseArticle(data?.article)
    const { title, thumbnail, digest } = article
    const targetPath = `/blog/${encodeURIComponent(articleId + '-' + title)}`
    const ogtitle = title ?? t('meta_blog_title')
    const ogdesc = `${digest.slice(0, 160)}...` ?? t('meta_blog_description')
    const ogimage = thumbnail ?? `${HOST}/images/tokenlon-og-banner.jpg`

    return {
      props: {
        openGraphData: [
          {
            property: 'og:url',
            content: `${HOST}${targetPath}`,
            key: 'ogurl',
          },
          {
            property: 'og:title',
            content: ogtitle,
            key: 'ogtitle',
          },
          {
            property: 'og:description',
            content: ogdesc,
            key: 'ogdesc',
          },
          {
            property: 'og:image',
            content: ogimage,
            key: 'ogimage',
          },
          {
            name: 'twitter:image',
            content: ogimage,
            key: 'twimage',
          },
        ],
      },
    }
  } catch (error) {
    return {
      props: {
        openGraphData: [
          {
            property: 'og:url',
            content: `${HOST}/blog/${articleId}`,
            key: 'ogurl',
          },
          {
            property: 'og:title',
            content: t('meta_blog_title'),
            key: 'ogtitle',
          },
          {
            property: 'og:description',
            content: t('meta_blog_description'),
            key: 'ogdesc',
          },
          {
            property: 'og:image',
            content: `${HOST}/images/tokenlon-og-banner.jpg`,
            key: 'ogimage',
          },
          {
            name: 'twitter:image',
            content: `${HOST}/images/tokenlon-og-banner.jpg`,
            key: 'twimage',
          },
        ],
      },
    }
  }
}

export default Article
